import { render } from "./FilterModuleProperties.vue?vue&type=template&id=10893690&scoped=true"
import script from "./FilterModuleProperties.vue?vue&type=script&lang=js"
export * from "./FilterModuleProperties.vue?vue&type=script&lang=js"

import "./FilterModuleProperties.vue?vue&type=style&index=0&id=10893690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10893690"]])

export default __exports__